import $ from 'jquery';

function VideoModal() {
	var $iframe = $('#video-modal').find('iframe'),
			$video  = $('#video-modal').find('video');
	
	if( $iframe.length ) {
		$(document).on('closed.zf.reveal', function() {
			$iframe.attr('src', $iframe.attr('src'));
		});
	}

	if( $video.length ) {
		$(document).on('closed.zf.reveal', function() {
			$video.trigger('pause');
		});
	}
}

export { VideoModal }